// Droits à l'écran (lot T5-0) : mêmes règles que le serveur (backend/metier.py : MANAGER_ROLES, roles_of, can,
// secretary_limited). Le serveur refuse de toute façon ce qui n'est pas permis : l'écran ne fait que cacher les boutons.
// Gestionnaire = Patron, secrétaire ou dispatcheur. Le rôle « dispatcher » n'existe qu'en transport.
// Secrétaire : tous les droits en conciergerie (M CARWASH : rien ne change) ; en transport, secrétaire administrative
// (ni attribution, ni étapes, ni annulation, ni suppression, ni Utilisateurs ; Réglages : partie facturation seulement,
// lot T5-0b, champs de metier.SECRETARY_SETTINGS_FIELDS).
import { useAuth } from "@/context/AuthContext";
import { useVocab } from "@/lib/vocab";

export const MANAGER_ROLES = ["master", "secretary", "dispatcher"];
export const ROLES = { conciergerie: ["master", "secretary", "employee"], transport: ["master", "dispatcher", "secretary", "employee"] };

// Libellé d'un rôle ; « employee » suit le métier (« Chauffeur » en transport, lot T1b-2) : rien ne change en base.
export const roleLabel = (role, voc) => ({ master: "Patron", dispatcher: "Dispatcheur", secretary: "Secrétaire", employee: voc.Employee }[role] || "");

export function rightsOf(user, business) {
  const role = user?.role;
  const manager = MANAGER_ROLES.includes(role);
  const secretaryLimited = role === "secretary" && business === "transport";
  const full = manager && !secretaryLimited;
  // dispatch : choisir le chauffeur et le véhicule, étapes, annuler, réactiver, supprimer, vue Équipe, « + » du Calendrier.
  // settingsBilling : page Réglages ouverte (tous les gestionnaires) ; settingsWrite : toute la page, sinon la partie
  // facturation seulement (secrétaire du transport, lot T5-0b).
  // dispatchHome (lot T5a) : page Dispatch en tête du menu et page d'arrivée (Patron et dispatcheur du transport).
  return { manager, secretaryLimited, dispatch: full, users: full, settingsWrite: full, settingsBilling: manager,
    dispatchHome: full && business === "transport" };
}

export function useRights() {
  const { user } = useAuth();
  const voc = useVocab();
  return rightsOf(user, voc.business);
}
